import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface ReportData {
  reportId: number | null;
  report_name: string | null;
  job_data: any; // you can replace `any` with a proper job data type if available
  report_date: string | null;
  report_format: "pdf" | "slides" | string; // or just string if more formats are possible
  templateId: number | null;
  job: any; // you can replace `any` with a proper job type if available
  templateName: string;
  report_link: string;
  cover_image: File | null;
  logo_image: File | null;
  cover_image_url: string | null;
  logo_image_url: string | null;
  search_log_id?: number | string | null;
  report_content_generated?: boolean;
}

interface ReportState {
  report_candidates: any;
  selected_candidate: any;
  selectedCandidate: any | null;
  template: any | null;
  subStepName: string | null;
  reportData: ReportData;
  data: any;
  actions_allowed: any;
}

export const initialReportData: ReportData = {
  reportId: null,
  report_name: null,
  job_data: null,
  report_date: null,
  search_log_id: null,
  report_format: "slides",
  templateId: null,
  job: null,
  templateName: "",
  report_link: "",
  cover_image: null,
  logo_image: null,
  cover_image_url: null,
  logo_image_url: null,
  report_content_generated: false,
};


export const templateSteps = [
  "selectReportType",
  "selectTemplate",
  "uploadCompanyDetails",
  // "addPrivacyStatement",
  "enabledPages",
  "addContent",
];


export const initialTemplate = [
  {
    stepName: "selectReportType",
    label: "Select Report Type",
    settings: {},
    enabled: true
  },
  // {
  //   stepName: "selectTemplate",
  //   label: "Select Template",
  //   settings: {},
  //   enabled: true
  // },
  {
    stepName: "enabledPages",
    label: "Pages",
    settings: [
      {
        label: "Cover Page",
        value: "uploadCompanyDetails",
        enabled: true,
        showLogo: true,
      },
      { label: "Privacy statement", value: "addPrivacyStatement", enabled: true },
      { label: "Content", value: "addContent", enabled: true },
      { label: "Brief in essence", value: "addBriefInEssence", enabled: true },
      { label: "Since we last met", value: "addSinceLastMet", enabled: true },
      { label: "Candidate Criteria", value: "addCandidateCriteria", enabled: true },
      { label: "Market Findings", value: "marketFindingsPage", enabled: true },
      { label: "Shortlisted Candidates", value: "candidateListPage", enabled: true },
      {
        label: "Candidate Summary",
        value: "addCandidateSummary",
        enabled: true,
        children: [
          { label: "Career Summary", value: "addCareerSummary", enabled: true },
          { label: "Assessment Overview ", value: "candidateInOwnPerspective", enabled: true },
          // { label: "Agency Perspective", value: "addAgencyPerspective", enabled: true },
          { label: "Advanced Biography", value: "candidateSocialSummary", enabled: true },

        ]
      },
      { label: "Next Steps", value: "addNextSteps", enabled: true },
    ],
    enabled: true
  },
  {
    stepName: "uploadCompanyDetails",
    label: "Company Details",
    settings: {
      companyName: null,
    },
    enabled: true
  },
  {
    stepName: "addPrivacyStatement",
    label: "Privacy statement",
    settings: {},
    enabled: true
  },
  {
    stepName: "addContent",
    label: "Content",
    settings: {
      mainHeading: "Content",
      // details: [
      //   {
      //     subHeading: "",
      //     description: ""
      //   }
      // ]
    },
    enabled: true
  },
  {
    stepName: "addBriefInEssence",
    label: "Brief in essence",
    settings: {},
    enabled: true
  },
  {
    stepName: "addSinceLastMet",
    label: "Since we last met",
    settings: {},
    enabled: true
  },
  {
    stepName: "addCandidateCriteria",
    label: "Candidate Criteria",
    settings: {},
    enabled: true
  },
  {
    stepName: "marketFindingsPage",
    label: "Market Findings",
    settings: {},
    enabled: true
  },
  {
    stepName: "candidateListPage",
    label: "Candidate List",
    settings: {},
    subSteps: [
      {
        stepName: "editCandidateBasicDetails",
        label: "Edit Candidate",
        settings: {},
        enabled: true
      },
      {
        stepName: "addCareerSummary",
        label: "Career Summary",
        settings: [
          // { label: "Education", value: "education", enabled: true },
          // { label: "Summary", value: "bio", enabled: true },
          { label: "LinkedIn Profile", value: "linkedin_url", enabled: true },
          { label: "Job Description", value: "work_description", enabled: true },
          // { label: "License & Certifications", value: "licenses", enabled: true },
          // { label: "Skills", value: "skills", enabled: true },
        ],
        enabled: true
      },
      // {
      //   stepName: "addAgencyPerspective",
      //   label: "Agency Perspective on Candidate",
      //   settings: {
      //     mainHeading: "",
      //     subHeading: "",
      //     description: [],
      //   },
      //   enabled: true
      // },
      {
        stepName: "candidateInOwnPerspective",
        label: "Assessment Overview",
        settings: {
          mainHeading: "",
          subHeading: "",
          description: [],
        },
        enabled: true
      },
      {
        stepName: "candidateSocialSummary",
        label: "Advanced Biography",
        settings: {
          mainHeading: "",
          subHeading: "",
          description: [],
        },
        enabled: true
      },


    ],
    enabled: true

  },
  {
    stepName: "addNextSteps",
    label: "Next Steps",
    settings: {},
    enabled: true
  },

];

const initialData = {
  addPrivacyStatement: {
    mainHeading: "Privacy statement",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addBriefInEssence: {
    mainHeading: "Brief in essence",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addSinceLastMet: {
    mainHeading: "Since we last met",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addCandidateCriteria: {
    mainHeading: "Candidate Criteria",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  marketFindingsPage: {
    mainHeading: "Market Findings",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addNextSteps: {
    mainHeading: "Next Steps",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },

};
const initialReportState: ReportState = {
  report_candidates: [],
  selectedCandidate: null,
  selected_candidate: null,
  template: initialTemplate,
  subStepName: null,
  reportData: initialReportData,
  data: initialData,
  actions_allowed: {}
};

export const getCompanyInfo = (state: ReportState) => {
  // Get company name from template
  const companyStep = state.template.find(
    (step: any) => step.stepName === "uploadCompanyDetails"
  );
  const { logo_image_url, job_data } = state.reportData;
  const companyName = companyStep?.settings?.companyName || job_data.recruiting_company || "";

  // Get URLs from reportData


  return {
    companyName,
    logoUrl: logo_image_url || job_data.company_image || "",
  };
};

const reportSlice = createSlice({
  name: "report",
  initialState: initialReportState,
  reducers: {
    setReportCandidates(state, action: PayloadAction<any>) {
      state.report_candidates = action.payload;
    },
    setSelectedCandidate(state, action: PayloadAction<any>) {
      state.selectedCandidate = action.payload;
    },
    setSelectedReportCandidate(state, action: PayloadAction<any>) {
      state.selected_candidate = action.payload;
    },
    setReportTemplate(state, action: PayloadAction<any>) {
      state.template = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string>) => {
      const uploadCompanyDetailsStep = state.template.find(
        (step: any) => step.stepName === "uploadCompanyDetails"
      );
      if (uploadCompanyDetailsStep) {
        uploadCompanyDetailsStep.settings.companyName = action.payload;
      }
    },
    resetReportTemplate(state) {
      state.template = initialTemplate;
    },
    setSubStepName(state, action: PayloadAction<string | null>) {
      state.subStepName = action.payload;
    },
    setReportData(state, action: PayloadAction<any>) {
      state.reportData = action.payload;
    },
    setActionsAllowed(state, action: PayloadAction<any>) {
      state.actions_allowed = action.payload;
    },
    setReportDataField(state, action: PayloadAction<Partial<ReportData>>) {
      state.reportData = {
        ...state.reportData,
        ...action.payload,
      };
    },
    setData(state, action: PayloadAction<Partial<any>>) {
      state.data = action.payload;
    },
    setDataField(
      state,
      action: PayloadAction<{
        stepName: string;
        key: string;
        value: any;
        subKey?: string;
        index?: number;
      }>
    ) {
      const { stepName, key, value, subKey, index } = action.payload;

      const stepData = state.data[stepName] || {};

      if (key === "details" && typeof index === "number" && subKey) {
        const updatedDetails = [...(stepData.details || [])];
        updatedDetails[index] = {
          ...updatedDetails[index],
          [subKey]: value,
        };
        state.data[stepName] = {
          ...stepData,
          details: updatedDetails,
        };
      } else {
        state.data[stepName] = {
          ...stepData,
          [key]: value,
        };
      }
    },
    addDataDetailRow(state, action: PayloadAction<string>) {
      const stepName = action.payload;
      const stepData = state.data[stepName] || {};
      const details = stepData.details || [];

      state.data[stepName] = {
        ...stepData,
        details: [...details, { subHeading: "", description: "" }],
      };
    },
    deleteDataDetailRow(
      state,
      action: PayloadAction<{ stepName: string; index: number }>
    ) {
      const { stepName, index } = action.payload;
      const stepData = state.data[stepName] || {};
      const details = stepData.details || [];

      const updatedDetails = details.filter((_: any, i: number) => i !== index);

      state.data[stepName] = {
        ...stepData,
        details: updatedDetails,
      };
    },
    resetEntireReportState() {
      return initialReportState;
    }
  }
});

export const {
  setReportCandidates,
  setSelectedCandidate,
  setSelectedReportCandidate,
  setReportTemplate,
  resetReportTemplate,
  setSubStepName,
  setReportData,
  setActionsAllowed,
  setReportDataField,
  setCompanyName,
  resetEntireReportState,
  setData,
  deleteDataDetailRow,
  setDataField,
  addDataDetailRow,
} = reportSlice.actions;

export default reportSlice.reducer;
